__webpack_require__.p = "https://assets-01.periodica.press/6424394-21950106384/";